"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerAggregator = exports.CustomerAggregatorType = void 0;
const EMAggregator_1 = require("./EMAggregator");
var CustomerAggregatorType;
(function (CustomerAggregatorType) {
    CustomerAggregatorType[CustomerAggregatorType["ALL"] = 0] = "ALL";
    CustomerAggregatorType[CustomerAggregatorType["CUSTOMER"] = 1] = "CUSTOMER";
    CustomerAggregatorType[CustomerAggregatorType["EM"] = 2] = "EM";
    CustomerAggregatorType[CustomerAggregatorType["EM_LEAD"] = 3] = "EM_LEAD";
    CustomerAggregatorType[CustomerAggregatorType["LEAD"] = 4] = "LEAD";
    CustomerAggregatorType[CustomerAggregatorType["MANAGER"] = 5] = "MANAGER";
    CustomerAggregatorType[CustomerAggregatorType["REGION"] = 6] = "REGION";
    CustomerAggregatorType[CustomerAggregatorType["SKILL"] = 7] = "SKILL";
    CustomerAggregatorType[CustomerAggregatorType["TEAM"] = 8] = "TEAM";
})(CustomerAggregatorType || (exports.CustomerAggregatorType = CustomerAggregatorType = {}));
class CustomerAggregator {
    constructor(year, month, teams, ems) {
        this.aggregators = new Map();
        this.aggregators.set(CustomerAggregatorType.ALL, () => [""]);
        this.aggregators.set(CustomerAggregatorType.CUSTOMER, (customer) => [customer.id]);
        this.aggregators.set(CustomerAggregatorType.EM, (customer) => [
            customer.engagementManager || "",
        ]);
        this.aggregators.set(CustomerAggregatorType.EM_LEAD, (customer) => {
            const emId = customer.engagementManager || "";
            const superiors = (0, EMAggregator_1.getEMSuperiors)(ems, emId);
            return [emId].concat(superiors.map((em) => em.id));
        });
        this.aggregators.set(CustomerAggregatorType.MANAGER, (customer) => {
            const teamId = customer.getTeam(year, month);
            const manager = teams[teamId]?.manager;
            return [manager || ""];
        });
        this.aggregators.set(CustomerAggregatorType.LEAD, (customer) => {
            const teamId = customer.getTeam(year, month);
            const lead = teams[teamId]?.lead;
            return [lead || ""];
        });
        this.aggregators.set(CustomerAggregatorType.REGION, (customer) => {
            return [customer.region || ""];
        });
        this.aggregators.set(CustomerAggregatorType.SKILL, (customer) => {
            const skills = customer.skills || [];
            return skills;
        });
        this.aggregators.set(CustomerAggregatorType.TEAM, (customer) => {
            const teamId = customer.getTeam(year, month);
            return [teamId || ""];
        });
    }
    get(customer, type) {
        const fn = this.aggregators.get(type);
        return fn(customer);
    }
}
exports.CustomerAggregator = CustomerAggregator;
//# sourceMappingURL=CustomerAggregator.js.map